import { useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { selfHireService } from '../services/selfHireService'

interface UseGetChartLinkProps {
  linkId: string
  enabled?: boolean
}

export const useGetChartLink = ({ linkId }: UseGetChartLinkProps) => {
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['linkChart', linkId],
    queryFn: async () => selfHireService.getChartLink(linkId),
    enabled: !!linkId,
  })

  const { toast } = useToast()

  if (isError) {
    toast({
      variant: 'destructive',
      title: 'Erro ao carregar o gráfico do link, tente novamente mais tarde!',
    })
  }

  return {
    isLoading,
    isFetching,
    data,
  }
}
